import { Chip, styled, Typography } from "@mui/material";
import React from "react";
import { chipColors } from "./constants";

const StyledChip = styled(Chip)({
    marginRight: "5px",
    marginBottom: "5px",
    border: `0.2em solid ${chipColors.hidden}`,
});

const ConditionChips = (props) => {
    const { noWrap } = props;
    const { conditions } = props.rule;
    return (
        <React.Fragment>
            <Typography noWrap={noWrap}>
                {conditions.map((condition, i) => {
                    const { conditionValue, conditionType, conditionOperator } = condition;
                    const label = conditionOperator
                        ? `${conditionType.displayName} ${conditionOperator.displayName} ${conditionValue}`
                        : conditionType.displayName;
                    return <StyledChip variant="outlined" key={i} label={label} />;
                })}
            </Typography>
        </React.Fragment>
    );
};

export default ConditionChips;
